var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"accent_color pointer text-dense",staticStyle:{"text-algin":"left"},on:{"click":_vm.getDetail}},[_vm._v(_vm._s(_vm.params.data.invoiceNumber||_vm.params.data.invoiceDocumentFilename))])])}
var staticRenderFns = []

export { render, staticRenderFns }